module.exports = __webpack_public_path__ + "media/images/diy/base_upgrade-4d0bf4bb32c40dc34738c0b6e6f0dba5.jpg";